import {CallJs} from "../../lib/types";

type Params ={downloadLogPage: string}
export const initToolbar: CallJs<Params> = (replace, params) => {
	{
		const eles = Array.from(document.getElementsByName('downloadLogEditButton'))
		eles.forEach(ele => {
			ele.onclick = () => {
				const serial: number[] = window.downloadLogListToolbarSelections
				if(serial.length == 1) {
					document.location.assign(
						params.downloadLogPage + "?command=displaydownloadlog&downloadLogSerial=" + serial[0]
					)
				}
			}
		})
	}

	{
		const eles = Array.from(document.getElementsByName('downloadLogExportButton'))
		eles.forEach(ele => {
			ele.onclick = () => {
				const serial: number[] = window.downloadLogListToolbarSelections
				const serials = serial.join(',')
				document.location.assign(
					params.downloadLogPage + "/export/?command=exportdownloadlog&downloadLogSerial=" + serials
				)
			}
		})
	}
}


// WEBPACK FOOTER //
// ./src/memory/component/download-log.ts